import React, { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import {
  GetAllNoHideSubsnameList,
  GetSubscriptionSetData,
} from "../../../../../../Api/ServiceDatas";
import DropDown, { OptionType } from "../../../../../Filters/DropDown";
import {
  HasInitValueBox,
  ModalRowContentContainer,
} from "../../../../AlimTalk/AlimTalkModal";
import { ModalRow } from "../../../../Users/UserDetail/BlackListModal/BlackListModal";
import { ModalLabel } from "../../../../Users/UserDetail/CommentModal/TargetContainer";
import { tempAccountModalState } from "../../TempAccount/TempAccountModal";
import { IAccountInfo } from "../TempAccount";
import { GetAllNoHideSubsnameListv3 } from "../../../../../../ApiTS/ServiceDatasTS_V3";
import { getSubsNameBySubsId3 } from "../../../../../../AdminApi/3.0_utils";

interface SubscriptionSectionProps {
  accountInfo?: IAccountInfo;
  type?: string;
}

export default function SubscriptionSection({
  accountInfo,
  type,
}: SubscriptionSectionProps) {
  const [subsValue, setSubsValue] = useState<OptionType>({
    value: accountInfo ? `${accountInfo?.servsubsid}` : "",
    label: accountInfo
      ? `${accountInfo?.servsubsid}_${getSubsNameBySubsId3(
          accountInfo?.servsubsid
        )}`
      : "선택",
  });
  const [tempAccountModalStateValue, setTempAccountModalStateValue] =
    useRecoilState(tempAccountModalState);

  const subsNameList = GetAllNoHideSubsnameListv3();

  const subsOptionList = [];

  for (let i = 0; i < subsNameList.length; i++) {
    const e = subsNameList[i];

    subsOptionList.push({
      value: e?.split("_")[0],
      label: e,
    });
  }

  useEffect(() => {
    if (subsValue?.value !== "") {
      setTempAccountModalStateValue({
        ...tempAccountModalStateValue,
        servsubsid: Number(subsValue?.value),
      });
    }
  }, [subsValue?.value]);

  return (
    <ModalRow>
      <ModalLabel>Subscription</ModalLabel>

      <ModalRowContentContainer>
        {type === "input" ? (
          <DropDown
            setDropDownValue={setSubsValue}
            optionList={subsOptionList}
            dropdownValue={subsValue}
          />
        ) : (
          <HasInitValueBox style={{ width: "100%" }}>
            {subsValue?.label}
          </HasInitValueBox>
        )}
      </ModalRowContentContainer>
    </ModalRow>
  );
}
